/**
 * @namespace P3.settings
 */
export default {
    /**
     * @static
     * @memberOf P3.settings
     * @type {boolean}
     * @default false
     */
    WARN_TEXTURE_DIVISIBLE_BY_2: true,

    /**
     * @static
     * @memberOf P3.settings
     * @type {boolean}
     * @default false
     */
    WARN_TEXTURE_DIVISIBLE_BY_4: false
}